var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.author
    ? _c(
        "div",
        { staticClass: "Author" },
        [
          _c("div", { staticClass: "back" }, [
            _c(
              "div",
              [
                _c("a", { staticClass: "volver", attrs: { href: "/" } }, [
                  _vm._v(_vm._s(_vm.$t("BUTTON.BACK")))
                ]),
                _c("span", { staticClass: "name" }, [
                  _vm._v(
                    _vm._s(_vm.author.Nombre) +
                      " " +
                      _vm._s(_vm.author.Apellidos)
                  )
                ]),
                _vm._l(_vm.author.userdatas, function(disciplina) {
                  return _c(
                    "span",
                    { key: disciplina.id, staticClass: "categoryHead" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "DISCIPLINE." +
                                disciplina.disciplina.txt.toUpperCase()
                            )
                          )
                      )
                    ]
                  )
                })
              ],
              2
            )
          ]),
          _c("div", { staticClass: "main" }, [
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "author-info" },
                [
                  _c("img", {
                    staticClass: "avatar",
                    attrs: {
                      src: _vm.loadImageServer(_vm.author.image, 0),
                      alt: ""
                    }
                  }),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.author.Nombre) +
                        " " +
                        _vm._s(_vm.author.Apellidos)
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "TERRITORY." + _vm.author.Territorio.txt.toUpperCase()
                        )
                      )
                    )
                  ]),
                  _vm._l(_vm.author.userdatas, function(disciplina) {
                    return _c(
                      "p",
                      { key: disciplina.id, staticClass: "category" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "DISCIPLINE." +
                                  disciplina.disciplina.txt.toUpperCase()
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm.currentDiscipline
                ? _c("div", { staticClass: "author-image" }, [
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "DISCIPLINE." +
                                _vm.currentDiscipline.disciplina.txt.toUpperCase()
                            )
                          ) +
                          " "
                      )
                    ]),
                    _c("div", { staticClass: "slider-button" }, [
                      _c(
                        "button",
                        { staticClass: "btn prev", on: { click: _vm.prev } },
                        [_vm._v(" " + _vm._s(_vm.$t("BUTTON.LAST")) + " ")]
                      ),
                      _c(
                        "button",
                        { staticClass: "btn next", on: { click: _vm.next } },
                        [_vm._v(" " + _vm._s(_vm.$t("BUTTON.NEXT")) + " ")]
                      )
                    ]),
                    _c("div", { staticClass: "carousel-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "carousel" },
                        [
                          _c(
                            "b-carousel",
                            {
                              attrs: {
                                id: "carousel-fade",
                                interval: 0,
                                "no-animation": ""
                              },
                              model: {
                                value: _vm.slide,
                                callback: function($$v) {
                                  _vm.slide = $$v
                                },
                                expression: "slide"
                              }
                            },
                            [
                              _c("b-carousel-slide", {
                                attrs: {
                                  "img-src": _vm.loadImageServer(
                                    _vm.author.userdatas[_vm.slide].image,
                                    1
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "buttons-dis" }, [
                        _c(
                          "div",
                          { staticClass: "add" },
                          [
                            _c(
                              "BaseDisButton",
                              {
                                attrs: { value: _vm.$t("BUTTON.NEW") },
                                on: { click: _vm.showModal2 }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/icons/plus.svg")
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "pen" },
                          [
                            _c(
                              "BaseDisButton",
                              {
                                attrs: { value: _vm.$t("BUTTON.EDIT") },
                                on: { click: _vm.showModal3 }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/icons/pen.svg")
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "trash" },
                          [
                            _c(
                              "BaseDisButton",
                              {
                                attrs: { value: _vm.$t("BUTTON.DELETE") },
                                on: { click: _vm.showModal }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/icons/trash.svg")
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              !_vm.currentDiscipline
                ? _c("div", { staticClass: "author-image" }, [
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(" " + _vm._s(_vm.$t("DISCIPLINEVIEW.NONE")) + " ")
                    ]),
                    _c("div", { staticClass: "carousel-wrapper" }, [
                      _vm._m(0),
                      _c("div", { staticClass: "buttons-dis" }, [
                        _c(
                          "div",
                          { staticClass: "add" },
                          [
                            _c(
                              "BaseDisButton",
                              {
                                attrs: { value: _vm.$t("BUTTON.NEW") },
                                on: { click: _vm.showModal2 }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/icons/plus.svg")
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "pen" },
                          [
                            _c(
                              "BaseDisButton",
                              {
                                attrs: { value: _vm.$t("BUTTON.EDIT") },
                                on: { click: _vm.showModal3 }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/icons/pen.svg")
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "trash" },
                          [
                            _c(
                              "BaseDisButton",
                              {
                                attrs: { value: _vm.$t("BUTTON.DELETE") },
                                on: { click: _vm.showModal }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/icons/trash.svg")
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.currentDiscipline
                ? _c("div", { staticClass: "author-description" }, [
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(" " + _vm._s(_vm.$t("AUTHOR.DESCRIPTION")) + " ")
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "description" }, [
                        _vm._v(
                          " " + _vm._s(_vm.currentDiscipline.descripcion) + " "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              !_vm.currentDiscipline
                ? _c("div", { staticClass: "author-description" }, [
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(" " + _vm._s(_vm.$t("AUTHOR.NODESCRIPTION")) + " ")
                    ])
                  ])
                : _vm._e()
            ])
          ]),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.isOpen
                ? _c("DeleteDiscipline", {
                    on: {
                      close: function($event) {
                        _vm.isOpen = false
                      },
                      deleteDiscpline: _vm.deleteDiscipline
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("div"),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.isOpen2
                ? _c("DisciplineForm", {
                    on: {
                      close: function($event) {
                        _vm.isOpen2 = false
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.isOpen3 && _vm.currentDiscipline
                ? _c("EditDiscipline", {
                    attrs: { discipline: _vm.currentDiscipline },
                    on: {
                      close: function($event) {
                        _vm.isOpen3 = false
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _c("div", [_c("BaseLoader")], 1)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "carousel" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/paints/noImagen2.jpg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }